import ReactDom from 'react-dom';
import './ErrorPopup.css';

export default function ErrorPopup({message}) {
    return ReactDom.createPortal(
        <div className="modalOverlay">
            <div className="modalPopup ErrorPopup">
                <div className="message">
                    {message}
                </div>
            </div>
        </div>,
        document.getElementById('modalRoot')
    );
}